export default "__VITE_ASSET__C1Z43qBn__"